import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgriaLogoWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 28,
	viewBox: "0 0 96 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18208_17402)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6885 21.6067V22.0342H43.9718V21.6067C45.2306 21.2747 45.6098 21.1322 45.6098 20.7754C45.6098 20.5611 45.4673 20.2772 45.2777 19.8262L44.1378 17.1201H38.6291L37.561 20.017C37.4421 20.349 37.3478 20.5869 37.3478 20.7765C37.3478 21.204 37.7989 21.2993 39.1284 21.6079V22.0353H34.166V21.6079C35.6851 21.1568 35.8994 21.1333 36.374 19.9463C37.0629 18.2129 41.8827 5.41602 41.8827 5.41602H43.2593L49.3616 19.9698C49.8362 21.1097 50.1683 21.2522 51.6885 21.6079V21.6067ZM43.6408 15.932L41.2432 10.2572H41.1714L39.0824 15.932H43.6408Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.5412 10.3528L62.1671 10.8274C62.8796 11.468 63.2352 12.4419 63.2352 13.8185C63.2352 16.8331 61.8822 17.522 57.9643 17.522C56.7302 17.522 55.7328 17.4266 54.9732 17.237C54.8779 17.7599 54.7836 18.4959 54.7836 18.8515C54.7836 19.3025 55.0922 19.6346 55.9 19.6346H60.0074C62.7382 19.6346 63.7109 19.9903 63.7109 22.7211C63.7109 26.1879 62.5003 27.256 59.6753 27.256H55.9482C53.3599 27.256 52.6475 26.7331 52.6475 25.3801C52.6475 24.597 53.0985 23.3382 53.8109 22.389C53.0031 21.9615 52.6475 21.202 52.6475 20.5131C52.6475 19.4215 53.0514 18.2098 54.2384 16.9756C53.0749 16.4292 52.6475 15.4318 52.6475 13.8185C52.6475 10.281 55.164 9.6875 57.9655 9.6875C59.6989 9.6875 62.4297 9.80643 64.5423 9.92535V10.3528H64.5412ZM54.5693 22.6515C54.5458 23.3168 54.5222 24.0046 54.5222 24.6699C54.5222 26.023 55.0686 26.1654 56.8727 26.1654H58.8675C60.8141 26.1654 61.1473 25.9512 61.1473 24.5038C61.1473 22.9365 60.6963 22.7233 58.7733 22.7233H55.4254C55.1169 22.7233 54.8319 22.6998 54.5705 22.6515H54.5693ZM59.6742 13.7489C59.6742 11.0664 59.2938 10.7814 57.9408 10.7814C56.5877 10.7814 56.2074 10.9003 56.2074 13.7489C56.2074 16.2419 56.5395 16.4315 57.9408 16.4315C59.5081 16.4315 59.6742 16.2419 59.6742 13.7489Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.6588 11.7303C75.6588 12.9173 75.2313 13.3212 74.0678 13.3212C72.9044 13.3212 72.4534 12.9173 72.4534 12.087C72.4534 11.8727 72.5005 11.6125 72.6194 11.4229C71.9552 11.4935 71.2181 11.8739 70.5775 12.3013V19.9698C70.5775 21.0614 70.6493 21.1568 72.358 21.6078V22.0353H65.4727V21.6078C67.2061 21.1568 67.2532 21.085 67.2532 19.9698V11.9928C67.2532 10.8765 67.2061 10.8058 65.4727 10.3548V9.9273H70.1029V11.6843C71.1946 10.3548 72.5487 9.68945 73.7593 9.68945C74.8756 9.68945 75.6588 10.3065 75.6588 11.7314V11.7303Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76.1758 21.6079C77.9092 21.1569 77.9563 21.0851 77.9563 19.9699V11.9929C77.9563 10.8765 77.9092 10.8059 76.1758 10.3548V9.92737H81.2806V19.971C81.2806 21.0626 81.3524 21.158 83.0611 21.609V22.0365H76.1758V21.609V21.6079ZM78.0281 6.27097C78.0281 5.3218 78.0999 5.25 79.0491 5.25H79.8557C80.8049 5.25 80.8767 5.3218 80.8767 6.27097V7.10232C80.8767 8.05149 80.8049 8.12329 79.8557 8.12329H79.0491C78.0999 8.12329 78.0281 8.05149 78.0281 7.10232V6.27097Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.9989 21.6067V22.0342C94.9779 22.1767 94.123 22.272 93.3634 22.272C92.2 22.272 91.3933 22.0342 91.0601 21.3229C90.3005 21.7974 88.8757 22.272 87.4519 22.272C85.244 22.272 84.3184 21.5596 84.3184 18.996C84.3184 16.4323 85.3158 15.6245 88.0219 15.6245H90.8952V13.7969C90.8952 11.4229 90.7291 11.3275 88.5211 11.3275C87.6427 11.3275 86.3838 11.3993 86.3838 11.3993V11.4711C87.5944 11.6607 87.9276 11.9221 87.9276 12.8477C87.9276 13.7733 87.4531 14.5093 86.266 14.5093C85.079 14.5093 84.628 13.9394 84.628 12.9184C84.628 10.5915 87.4059 9.68945 90.516 9.68945C92.8664 9.68945 94.2195 10.9483 94.2195 13.3223V19.8991C94.2195 21.0154 94.4573 21.3475 96 21.609L95.9989 21.6067ZM90.8941 20.634V16.5737C87.9018 16.5972 87.784 16.7633 87.784 18.9477C87.784 20.5622 88.1879 20.8472 89.4456 20.8472C89.9202 20.8472 90.443 20.7754 90.8941 20.6329V20.634Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.975 0.125H0V28.1H27.975V0.125Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.5576 2.01367V8.73181H19.332V26.17H26.0322V2.01367H10.5576Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.94336 2.01367V26.17H17.4179V19.4507H8.64351V2.01367H1.94336Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.4169 10.6523H10.5576V17.5312H17.4169V10.6523Z",
					fill: "#E30613"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18208_17402",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 96,
				height: 27.975,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAgriaLogoWhite);
export { ForwardRef as ReactComponent };
